import { render, staticRenderFns } from "./email-order-modal.vue?vue&type=template&id=27f6354b&scoped=true"
import script from "./email-order-modal.vue?vue&type=script&lang=js"
export * from "./email-order-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6354b",
  null
  
)

export default component.exports